import { useEffect, useState } from 'react';

import { api } from 'services/api';

import { IDestinationType } from '../models/product';

export function useDestinations(): IDestinationType[] {
  const [productDestination, setProductDestination] = useState<
    IDestinationType[]
  >([]);

  useEffect(() => {
    api
      .get<{ data: string[] }>('/admin/filter-options/destinations')
      .then(({ data }) => {
        setProductDestination(
          data.filter(item => !!item).map(destination => ({ destination }))
        );
      })
      .catch(err => Promise.reject(err.message));
  }, []);

  return productDestination;
}
